import React, { useState, useEffect } from "react";
import { iepaProd } from "../constants/global";

// const [routes, setRoutes] = useState(initialRoutes);

const CustomerData = () => {
  const [customersdata, setCustomersdata] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchData();
  }, []); //Empty dependency array ensures the effect runs once on mount

  const _render = (obj) => {
    return <code>{JSON.stringify(obj)}</code>; //here also jsx syntax are valid.
  };

  //Function to fetch Date
  const fetchData = async () => {
    try {
      const response = await fetch(
        `${iepaProd.iepaUserSrvAPI}/customer/active/all/org/1`
      );
      if (!response.ok) {
        throw new Error("The response was not ok.");
      }
      const result = await response.json();
      setCustomersdata(result);
    } catch (error) {
      console.error("Error fetchimng the data");
    }
  };

  return customersdata ? _render(customersdata) : <p>Loading.....</p>;
};
export default CustomerData;
